var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRacSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.245,
    height: 18.4,
    viewBox: "0 0 23.245 18.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11987",
    "data-name": "Group 11987",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37942",
    "data-name": "Path 37942",
    d: "M5.009,18.99c0,1.062.009,2.122,0,3.182a1.037,1.037,0,1,1-2.073.014c-.006-.974-.009-1.948,0-2.922a.316.316,0,0,0-.251-.369,3.947,3.947,0,0,1-.013-7.473.339.339,0,0,0,.266-.393q-.01-4.951,0-9.9A1.036,1.036,0,0,1,4.319.065a1.058,1.058,0,0,1,.689,1.068q0,2.678,0,5.357c0,1.515,0,3.03,0,4.545a.321.321,0,0,0,.25.373A3.953,3.953,0,0,1,5.232,18.9C5.162,18.926,5.094,18.956,5.009,18.99Zm.854-3.838a1.894,1.894,0,1,0-1.9,1.893A1.89,1.89,0,0,0,5.863,15.152Z",
    transform: "translate(0 7.939) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37943",
    "data-name": "Path 37943",
    d: "M5.009,4.255c0-1.062.009-2.122,0-3.182a1.037,1.037,0,1,0-2.073-.014c-.006.974-.009,1.948,0,2.922a.316.316,0,0,1-.251.369,3.947,3.947,0,0,0-.013,7.473.339.339,0,0,1,.266.393q-.01,4.951,0,9.9A1.036,1.036,0,0,0,4.319,23.18a1.058,1.058,0,0,0,.69-1.068q0-2.678,0-5.357c0-1.515,0-3.03,0-4.545a.321.321,0,0,1,.25-.373,3.953,3.953,0,0,0-.024-7.494C5.162,4.319,5.094,4.289,5.009,4.255Zm.854,3.838A1.894,1.894,0,1,1,3.962,6.2,1.89,1.89,0,0,1,5.863,8.093Z",
    transform: "translate(0 18.4) rotate(-90)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacSort);
export default __webpack_public_path__ + "static/media/RacSort.a17dc026.svg";
export { ForwardRef as ReactComponent };